module.exports = __webpack_public_path__ + "static/media/phoneIcon.75bfaff8.svg";